module.exports = __webpack_public_path__ + "static/media/remote1.59f27047.jpg";